export enum DunningActionListSortProp {
	DunningActionId = 'DunningActionId',
	RealizationDate = 'RealizationDate',
	DunningAmountInvoicing = 'DunningAmountInvoicing',
	TotalBalanceInvoicing = 'TotalBalanceInvoicing',
}
